import React, { useState } from "react";
import { ViewIcon, HideIcon } from "@shopify/polaris-icons";
import { Button, LegacyCard, TextField, Icon } from "@shopify/polaris";
import FormErrorMessage from "../FormErrorMessage";
import { getPasswordError } from "../../utils/formUtils";
import { Formik } from "formik";
import FamilyImage from "../../assets/consult/consult-family-illustration.png";
import { css, StyleSheet } from "aphrodite";
import { useActions } from "tiny-atom/react/hooks";
import { logEvent } from "../../actions";
import { TouchableOpacity } from "../react-native";
import ButtonComponent from "../Button";

export default function ConsultScreenerPasswordInput({ onPasswordSubmitted }) {
  const { setConsultCallback } = useActions();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);
  const [hidePassword, setHidePassword] = useState(true);

  const validateForm = () => {
    const errors = {};
    const error = getPasswordError(password);
    if (error) {
      errors.password = error;
    }
    return errors;
  };

  const submit = () => {
    setLoading(true);
    onPasswordSubmitted(password).then(() => {
      setLoading(false);
    });
  };

  return (
    <div className={css(styles.container)}>
      <LegacyCard>
        <LegacyCard.Section>
          <div className={css(styles.columnCentered)}>
            <img src={FamilyImage} className={css(styles.image)} />
            <p className={css(styles.title)}>You’re almost there!</p>
            <p className={css(styles.subtitle)}>Create a password for your Manatee account to complete your booking.</p>
            <p className={css(styles.subtitleGray, styles.font14)}>Already have the Manatee app?</p>
            <p className={css(styles.subtitleGray, styles.font14)}>Enter your existing password.</p>
            <div className={css(styles.formContainer)}>
              <Formik initialValues={{ password: "" }} onSubmit={submit} validate={validateForm}>
                {({ handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <FormErrorMessage name="password" component="div" />
                    <div className={css(styles.paddingTop)}>
                      <TextField
                        placeholder="password"
                        onChange={setPassword}
                        type={hidePassword ? "password" : "text"}
                        name="password"
                        value={password}
                      />
                      <div className={css(styles.showHidePassword)}>
                        <Button
                          onClick={() => setHidePassword(!hidePassword)}
                          plain
                          size={"slim"}
                          icon={
                            <Icon
                              source={hidePassword ? ViewIcon : HideIcon}
                              onClick={() => setHidePassword(!hidePassword)}
                            />
                          }
                        ></Button>
                      </div>
                    </div>
                    <div className={css(styles.paddingTop, styles.paddingBottom)}>
                      <ButtonComponent
                        small
                        submit
                        theme="manaBlue"
                        disabled={loading}
                        loading={loading}
                        onPress={handleSubmit}
                        title="Continue"
                      ></ButtonComponent>
                    </div>
                    <TouchableOpacity
                      style={{ cursor: "pointer" }}
                      disabled={loading}
                      loading={loading}
                      onPress={() => {
                        logEvent("careScreenerResetPassword");
                        return setConsultCallback({ params: { consultCallback: onPasswordSubmitted } });
                      }}
                    >
                      <p className={css(styles.paddingTop, styles.subtitle, styles.font14, styles.underline)}>
                        I forgot my password
                      </p>
                    </TouchableOpacity>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </LegacyCard.Section>
      </LegacyCard>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 350,
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  columnCentered: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  image: {
    width: "90%",
    height: "20vh",
    objectFit: "contain",
    aspectRatio: 1,
    marginTop: 20,
    marginBottom: 10
  },
  title: {
    fontFamily: "Helvetica",
    color: "#1A2579",
    fontWeight: 800,
    fontSize: 24,
    lineHeight: 1.2,
    textAlign: "center",
    marginBottom: 10,
    marginTop: 20
  },
  subtitle: {
    fontFamily: "Helvetica",
    color: "#2562D8",
    fontSize: 18,
    lineHeight: 1.4,
    fontWeight: 500,
    textAlign: "center",
    marginBottom: 20
  },
  underline: {
    textDecoration: "underline"
  },
  subtitleGray: {
    fontFamily: "Helvetica",
    color: "#636C8C",
    fontSize: 18,
    lineHeight: 1.4,
    fontWeight: 500,
    textAlign: "center"
  },
  forgotPassword: {
    textAlign: "center",
    fontSize: 14,
    lineHeight: 1.4,
    color: "#919eab",
    marginTop: 20
  },
  resetPasswordButton: {
    ":nth-child(1n) > button": {
      width: "148px"
    }
  },
  formContainer: {
    width: 250,
    marginTop: 10
  },
  paddingTop: {
    paddingTop: 15,
    position: "relative"
  },
  paddingBottom: {
    paddingBottom: 15
  },
  font14: {
    fontSize: 14
  },
  showHidePassword: {
    position: "absolute",
    top: "1.5rem",
    right: "0",
    zIndex: "40"
  }
});
